import {HubConnectionBuilder, LogLevel} from '@microsoft/signalr';
import env from '../../../util/env';

export default function getConnection(eventHandlers) {
	const config = env.getDocHelperConfig();
	const connection = new HubConnectionBuilder()
		.configureLogging(LogLevel.Error)
		.withUrl(config.SignalRHubUrl)
		.withAutomaticReconnect({
			nextRetryDelayInMilliseconds: (retry) => 5000 + retry.previousRetryCount * 2000
		})
		.build();

	Object.entries(eventHandlers).forEach((args) => connection.on(...args));

	return connection.start().then(() => connection);
}
